<template>
  <div
    v-show="loginState == 'SMS_LOGIN' || loginState == 'SMS_REGISTRY'"
    style="width: calc(100% - 100px)"
  >
    <h3 class="mb-3 text-2xl font-bold enter-x">
      {{ isSign ? '注册' : '验证码登入' }}
    </h3>
    <a-form :form="form" @submit="handleLogin" class="enter-x">
      <a-form-item class="enter-x">
        <a-input
          placeholder="手机号码"
          v-decorator="[
            'username',
            {
              rules: [
                {
                  required: true,
                  message: '请输入手机号码',
                },
              ],
            },
          ]"
          :disabled="disabled"
          size="large"
          class="fix-auto-fill"
        ></a-input>
      </a-form-item>
      <a-form-item v-if="isSign">
        <a-input-password
          placeholder="密码"
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: '请输入密码',
                },
              ],
            },
          ]"
          size="large"
        ></a-input-password>
      </a-form-item>
      <a-form-item v-if="isSign">
        <a-input-password
          placeholder="重复密码"
          v-decorator="[
            'sec_password',
            {
              rules: [
                {
                  required: true,
                  message: '请输入重复密码',
                },
              ],
            },
          ]"
          size="large"
        ></a-input-password>
      </a-form-item>
      <a-form-item>
        <div class="overflow-hidden">
          <div class="float-left" style="width: calc(100% - 160px)">
            <a-input
              placeholder="验证码"
              v-decorator="[
                'captcha',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入验证码',
                    },
                  ],
                },
              ]"
              size="large"
            >
            </a-input>
          </div>
          <div class="float-right overflow-hidden">
            <a-button
              class="float-right"
              size="large"
              style="width: 150px"
              :loading="sms_loading"
              :disbled="isStart"
              @click="sendCode"
              >{{ isStart ? `${currentCount}s后重新获取` : '获取验证码' }}</a-button
            >
          </div>
        </div>
      </a-form-item>
      <a-form-item><PolicyModel></PolicyModel></a-form-item>
      <a-form-item>
        <a-button type="primary" block size="large" html-type="submit" :loading="login_loading">{{
          isSign ? '注册' : '登录'
        }}</a-button>
        <a-button class="mt-4" block size="large" @click="handleBackLogin">返回</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { sendSmscode } from '@/api/user';
  import { passwordStrength } from 'check-password-strength';
  import PolicyModel from '@/components/LoginPolicymodel/index';
  export default {
    components: {
      PolicyModel,
    },
    data() {
      return {
        login_loading: false,
        sms_loading: false,
        codetips: '获取验证码',
        form: this.$form.createForm(this, { name: 'mobile' }),
        timerId: null,
        isStart: false,
        disabled: false,
        currentCount: 60,
      };
    },
    computed: {
      ...mapState('user', ['loginState', 'phone', 'pwd']),
      isSign() {
        return this.loginState == 'SMS_REGISTRY';
      },
    },
    watch: {
      phone(a) {
        if (a) {
          setTimeout(() => this.form.setFieldsValue({ username: a }), 1);
          this.disabled = true;
        } else {
          setTimeout(() => this.form.setFieldsValue({ username: '' }), 1);
          this.disabled = false;
        }
      },
    },
    methods: {
      handleBackLogin() {
        this.$store.commit('user/SET_LOGINSTATE', { state: 'PASSWORD' });
      },
      async handleLogin(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            if (this.isSign) {
              if (values.sec_password != values.password) {
                this.$message.error('请输入相同的密码');
                return;
              }
              if (passwordStrength(values.password).id == 0) {
                this.$message.error('请输入大于6位并包含数字及字母的密码');
                return;
              }
              values.type = 2;
            } else {
              if (this.disabled) {
                values.type = 0;
                values.password = this.pwd;
              } else {
                values.type = 1;
              }
            }
            this.login_loading = true;
            try {
              const userInfo = await this.$store.dispatch('user/login', values);
              if (userInfo) {
                this.$notification.success({
                  message: '登入成功',
                  description: `欢迎回来: ${userInfo.name}`,
                  duration: 3,
                });
                this.$router.push(`/admin/contract`);
              }
            } catch (error) {
              console.log(error);
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.login_loading = false;
            }
          }
        });
      },
      async sendCode() {
        let mobile = this.form.getFieldValue('username');
        if (!/^1\d{10}$/.test(mobile)) {
          this.$message.error('请输入正确的手机号码');
          return;
        }
        await sendSmscode({ tel: mobile });
        this.start();
      },
      start() {
        if (this.isStart || !!this.timerId) {
          return;
        }
        this.isStart = true;
        this.timerId = setInterval(() => {
          if (this.currentCount === 1) {
            this.stop();
            this.currentCount = 60;
          } else {
            this.currentCount -= 1;
          }
        }, 1000);
      },
      stop() {
        this.isStart = false;
        this.clear();
        this.timerId = null;
      },
      clear() {
        this.timerId && window.clearInterval(this.timerId);
      },
    },
  };
</script>
<style scoped lang="less">
  :deep(.ant-btn-primary) {
    background-color: #0960bd;
  }
</style>
